<template>
  <v-toolbar
    flat
    :class="getTheme() == 'dark' ? 'elevation-0 white--text' : 'elevation-0 #505050--text'"
    :style="getTheme() == 'dark' ? 'background-color: #505050' : 'background-color: white'"
    :src="getTheme() == 'dark' ? netBackImage : ''"
  >
    <v-btn
      v-if="btn"
      fab
      class="elevation-0"
      :color="getTheme() == 'dark' ? 'white' : 'primary'"
      small
      :to="path"
    >
      <v-icon
        :class="
                    getTheme() == 'dark' ? 'primary--text' : 'white--text'
                  "
      >{{ icon }}</v-icon>
    </v-btn>
    <v-icon v-else :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'">{{ icon }}</v-icon>
    <v-toolbar-title class="ml-2">
      <slot></slot>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  name: "main-sub-page-toolbar",
  props: {
    icon: {
      type: String,
      required: true
    },
    path: {
      type: String
    },
    btn: {
      type: Boolean
    }
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png")
    };
  }
};
</script>

<style scoped>
</style>